<template>
    <div class="image-container" 
        :class="[asset.showMobile ? 'show-mobile' : '', `asset-${asset.type}`]"
        :style="asset.style">
        <template v-if="asset.type === 'embed'">
            <div ref="embedWrapper" v-html="lazyLoadEmbed"></div>
        </template>
        <figure v-if="asset.type === 'video' || asset.type === 'image'">
            <video v-if="asset.type === 'video'" class="gallery-item lazy" :aria-describedby="`${assetIndex}-figcaption`" autoplay muted loop playsinline poster="">
                <source v-for="src in asset.path"
                    :key="src.index"  
                    class="lazy"
                    :data-src="require(`../assets/${src}`)" 
                    :type="`video/${getFileType(src)}`" >
            </video>
            <img v-if="asset.type === 'image'" 
                 class="gallery-item lazy" 
                 :data-src="require(`../assets/${asset.path}`)" 
                 :alt="asset.alt" 
                 :aria-describedby="`${assetIndex}-figcaption`"/>
            <figcaption 
                v-if="asset.longDescription" 
                :id="`${assetIndex}-figcaption`" 
                aria-hidden="false">{{asset.longDescription}}</figcaption>
            <!-- <button class="expand">
                <img :src="require('../assets/zoom.svg')" alt="Expand Image" />
            </button> -->
        </figure>
    </div>
</template>

<script>

export default {
  name: 'Asset',
  props: ['asset', 'isOpen', 'assetIndex'],
  data() {
    return {
      activeTl: null,
    }
  },
  computed: {
    lazyLoadEmbed() {
        if (this.isOpen && this.$refs.embedWrapper.innerHTML === '') {
            return this.asset.embedCode;
        }
        else return ''
    },
  },
  methods: {
    getFileType(path) {
        return (/[.]/.exec(path)) ? /[^.]+$/.exec(path) : undefined;
    },
  },
}
</script>

<style lang="less" >
    .image-container {
        position: absolute;
        overflow: hidden;
        border-radius: 5px;
        line-height: 0;
        border: none;
        padding: 0;
        background: transparent;
        box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, 
                    rgba(0, 0, 0, 0.07) 0px 2px 4px, 
                    rgba(0, 0, 0, 0.07) 0px 4px 8px, 
                    rgba(0, 0, 0, 0.07) 0px 8px 16px, 
                    rgba(0, 0, 0, 0.07) 0px 16px 32px, 
                    rgba(0, 0, 0, 0.07) 0px 32px 64px;
        @media (max-width: 799px) {
            transform: none !important;
            width: 100% !important;
            margin-top: 25px;
            display: none;
            &.show-mobile { 
                position: relative;
                display: block;
            }
        }
        &:last-child { position: absolute; }
        &.asset-embed { position: relative; }
        // &:hover:not(.active){
        //     cursor: pointer;
        //     .expand {transform: scale(1) rotate(0deg) translateX(-50%) translateY(-50%) translateZ(0);}
        // }
        // &:focus-within {
        //     box-shadow: #9fffee 0px 0px 30px 10px, 
        //                 #9fffee 0px 0px 0px 4px; 
        // }
        figure { margin: 0;}
        figcaption { opacity: 0; visibility: visible;}
        img, video { 
            pointer-events: none;
            width: 100%; 
            transition: all .15s linear;
        }
        iframe, embed, object { 
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
        // .expand {
        //     outline: none;
        //     background: transparent;
        //     border: none;
        //     display: block;
        //     top: 50%;
        //     left: 50%;
        //     transform: scale(0) rotate(-45deg) translateX(-50%) translateY(-50%) translateZ(0);
        //     position: absolute;
        //     width: 65px;
        //     transition: all .25s cubic-bezier(0.34, 1.75, 0.64, 1);
        //     transform-origin: top left;
        //     pointer-events: none;
        //     &:focus {transform: scale(1) rotate(0deg) translateX(-50%) translateY(-50%) translateZ(0);}
        // }
    }
</style>
